<account-menu [selectedMenu]="2" [me]="me"></account-menu>

<div class="col-lg-9 col-md-9 col-sm-8 content-panel-wrapper no-padding-mobile">

  <h2 class="page-title">Account Profile</h2>

  <div class="page-sub-title">View and amend your personal information</div>

  <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
    <div class="panel">
      <div class="panel-title">Personal Details</div>

      <div class="col-sm-6">
        <div class="form-elem">
          <div class="form-elem-name">First Name</div>
          <div class="form-elem-field">
            <input type="text" [formControl]="myForm.controls['firstname']" [(ngModel)]="model.firstname" />
            <div class="mb-error-fail-wrap"
                 *ngIf="!myForm.controls['firstname'].valid && myForm.controls['firstname'].touched">
              <div class="mb-error-fail">Please enter your FIRST NAME</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-elem">
          <div class="form-elem-name">Last Name</div>
          <div class="form-elem-field">
            <input type="text" [formControl]="myForm.controls['lastname']" [(ngModel)]="model.lastname" />
            <div class="mb-error-fail-wrap"
                 *ngIf="!myForm.controls['lastname'].valid && myForm.controls['lastname'].touched">
              <div class="mb-error-fail">Please enter your LAST NAME</div>
            </div>
          </div>
        </div>
      </div>

      <div class="clear"></div>

      <div class="col-sm-12">
        <div class="form-elem">
          <div class="form-elem-name">Telephone</div>
          <div class="form-elem-field">
            <input type="text" [formControl]="myForm.controls['tel']" [(ngModel)]="model.tel" />
            <div class="mb-error-fail-wrap" *ngIf="!myForm.controls['tel'].valid && myForm.controls['tel'].touched">
              <div class="mb-error-fail">Please enter your TELEPHONE CONTACT NUMBER</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-elem">
          <div class="form-elem-name">Country</div>
          <div class="form-elem-field">
            <select [(ngModel)]="model.country" [formControl]="myForm.controls['country']" [compareWith]="equalCountry">
              <option *ngFor="let item of countryList" [ngValue]="item">{{item.name}}</option>
            </select>
            <div *ngIf="!myForm.controls['country'].valid && myForm.controls['country'].touched"
                 class="mb-error-fail-wrap">
              <div class="mb-error-fail">Please select your COUNTRY</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6" *ngIf="model.country?.name === 'United States of America'">
        <div class="form-elem">
          <div class="form-elem-name">State</div>
          <div class="form-elem-field">
            <select [(ngModel)]="model.state" [formControl]="myForm.controls['state']">
              <option [ngValue]="null">-- Select a state --</option>
              <option *ngFor="let item of stateList" [ngValue]="item">{{item}}</option>
            </select>
            <div class="mb-error-fail-wrap" *ngIf="model.country?.name === 'United States of America' && !myForm.controls['state'] && myForm.controls['state'].touched">
              <div class="mb-error-fail">Please enter your STATE</div>
            </div>
          </div>
        </div>
      </div>

      <div class="clear"></div>

      <div class="col-sm-12">
        <div class="form-elem">
          <div class="form-elem-name">Address Line 1</div>
          <div class="form-elem-field">
            <input type="text" [formControl]="myForm.controls['addressLine1']" [(ngModel)]="model.addressLine1" />
            <div class="mb-error-fail-wrap"
                 *ngIf="!myForm.controls['addressLine1'].valid && myForm.controls['addressLine1'].touched">
              <div class="mb-error-fail">Please enter your ADDRESS</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-12">
        <div class="form-elem">
          <div class="form-elem-name">Address Line 2</div>
          <div class="form-elem-field">
            <input type="text" [formControl]="myForm.controls['addressLine2']" [(ngModel)]="model.addressLine2" />
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-elem">
          <div class="form-elem-name">City</div>
          <div class="form-elem-field">
            <input type="text" [(ngModel)]="model.city" [formControl]="myForm.controls['city']" />
            <div *ngIf="!myForm.controls['city'].valid && myForm.controls['city'].touched" class="mb-error-fail-wrap">
              <div class="mb-error-fail">Please select your CITY</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-elem">
          <div class="form-elem-name">Post Code</div>
          <div class="form-elem-field">
            <input type="text" [formControl]="myForm.controls['postcode']" [(ngModel)]="model.postcode" />
            <div class="mb-error-fail-wrap"
                 *ngIf="!myForm.controls['postcode'].valid && myForm.controls['postcode'].touched">
              <div class="mb-error-fail">Please enter your POST CODE</div>
            </div>
          </div>
        </div>
      </div>

      <div class="clear"></div>
    </div>

    <!-- Submit Buttons -->
    <div class="col-sm-12 form-elem nopadding">
      <div class="col-xs-6">
        <button type="submit" class="btn-main-proceed">Save</button>
      </div>
      <div class="col-xs-6">
        <button type="button" class="btn-main-caution" routerLink="/">Cancel</button>
      </div>
    </div>
  </form>
</div>
